import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfPen,
  PdfColor,
  PdfPoint,
  PdfRect,
  PdfFont,
  PdfBrush,
  ETextAlign,
  PageGen,
} from '../../pdf/pdf';
import { PDFFont, StandardFonts } from 'pdf-lib';
import { ILayoutBaseGen } from '../layoutBase';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/cut';
import { GUtil } from '../../pdf/gutil';

export class Blocek_Procenta implements ILayoutBaseGen {
  public async generate(pdf: PdfGen): Promise<void> {
    const baseFont = new PdfFont(PdfFont.FONT_NAME, 24);

    // C# logic: var fractionPen = new XPen(XColors.Black, 2);
    const fractionPen = new PdfPen(PdfColor.fromHex('#000000'), 2);

    const count = 3;
    const top = PdfUnit.FromMillimeters(12);
    const margin = PdfUnit.FromMillimeters(5);
    const size = new PdfSize(PdfSize.A4.width / count, PdfSize.A4.height / count);

    let index = 0;

    // We need 12 pages to cover 0-100+
    for (let p = 0; p < 12; p++) {
      const page = pdf.addPage();
      const size100 = page.measureString('100', baseFont);

      for (let i = 0; i < count; i++) {
        page.drawLine(
          GUtil.cutPen,
          new PdfPoint(i * size.width, 0),
          new PdfPoint(i * size.width, PdfSize.A4.height)
        );
        page.drawLine(
          GUtil.cutPen,
          new PdfPoint(0, i * size.height),
          new PdfPoint(PdfSize.A4.width, i * size.height)
        );
      }

      for (let y = 0; y < count; y++) {
        for (let x = 0; x < count; x++) {
          if (index > 100) continue;

          const rr = new PdfRect(x * size.width, y * size.height, size.width, size.height);
          const rect = new PdfRect(rr.x, rr.y + top, rr.width, rr.height - top);

          page.cutCircle(new PdfPoint(rr.x + size.width * 0.25, rr.y + top / 2), true);
          page.cutCircle(new PdfPoint(rr.x + size.width * 0.75, rr.y + top / 2), true);

          const centerX = rect.x + rect.width / 2;
          const centerY = rect.y + rect.height / 2;

          page.drawLine(
            GUtil.basePen,
            new PdfPoint(centerX, rect.top),
            new PdfPoint(centerX, rect.bottom)
          );
          page.drawLine(
            GUtil.basePen,
            new PdfPoint(rect.left, centerY),
            new PdfPoint(rect.right, centerY)
          );
          page.drawLine(GUtil.basePen, rect.topLeft, rect.topRight);

          for (let yy = 0; yy < 2; yy++) {
            for (let xx = 0; xx < 2; xx++) {
              const r = new PdfRect(
                rect.x + (xx * rect.width) / 2,
                rect.y + (yy * rect.height) / 2,
                rect.width / 2,
                rect.height / 2
              );
              const rm = new PdfRect(
                r.x + margin,
                r.y + margin,
                r.width - 2 * margin,
                r.height - 2 * margin
              );

              if (xx === 0 && yy === 0) {
                const rr1 = new PdfRect(rm.x, rm.y, rm.width, rm.height / 2);
                const rr2 = new PdfRect(rm.x, rm.y + rm.height / 2, rm.width, rm.height / 2);

                const rmCenterX = rm.x + rm.width / 2;
                const rmCenterY = rm.y + rm.height / 2;

                page.drawLine(
                  fractionPen,
                  new PdfPoint(rmCenterX - size100.width / 2, rmCenterY),
                  new PdfPoint(rmCenterX + size100.width / 2, rmCenterY)
                );

                page.drawString(`${index}`, baseFont, PdfBrush.Black, null, rr1, ETextAlign.Center);
                page.drawString('100', baseFont, PdfBrush.Black, null, rr2, ETextAlign.Center);
              } else if (xx === 1 && yy === 0) {
                const val = (index / 100).toFixed(2);
                page.drawString(val, baseFont, PdfBrush.Black, null, rm, ETextAlign.Center);
              } else if (xx === 0 && yy === 1) {
                page.drawString(
                  `${index} %`,
                  baseFont,
                  PdfBrush.Black,
                  null,
                  rm,
                  ETextAlign.Center
                );
              } else if (xx === 1 && yy === 1) {
                const color = PdfColor.fromHsl((360.0 / 100) * index, 1.0, 0.5);
                const brush = new PdfBrush(color);

                const square = rm.centerSquare();
                const sz = new PdfSize(square.width / 10, square.height / 10);

                for (let y1 = 0; y1 < 10; y1++) {
                  for (let x1 = 0; x1 < 10; x1++) {
                    const rx = new PdfRect(
                      square.x + x1 * sz.width,
                      square.y + y1 * sz.height,
                      sz.width,
                      sz.height
                    );
                    const num = y1 * 10 + x1;

                    if (num < index) {
                      page.drawRectangle(null, brush, rx);
                    }
                    page.drawRectangle(GUtil.basePen, null, rx);
                  }
                }
              }
            }
          }
          index++;
        }
      }
    }
  }
}
